<template>
<div class="social_front_end-container">
  <div class="content">

    <div class="content-header">
      <div class="header-logo"></div>
      <div class="header-text"><span class="header-text1">JAVA工程师</span> <br><span class="header-text2">JAVA ENGINEER</span></div>
      <!-- <div class="header-btn" >立即投递</div> -->
      <div class="header-btn" > <Upload></Upload></div>
    </div>
    <div class="content-detailed">
      <div>  <img src="../../../../assets/logo/路径 292.png" alt="">  合肥-蜀山</div>
      <div class="detailed-text2">本科及以上&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1-3年&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;招聘4人</div>
      <div>于2022-03-31发布</div>
    </div>

    <div class="content-job">
      <div class="job-title">工作职责</div>
      <div class="job-text">1、按照公司、项目要求，独立搭建后端开发框架；<br>2、对公司现有技术框架可以调优；<br>3、按照项目要求,撰写相关软件过程文档。</div>
    </div>

    <div class="content-job">
      <div class="job-title">任职要求</div>
      <div class="job-text">1、精通SSM框架，熟练基于SpringBoot、SpringCloud、service mesh等主流框架和微服务架构；<br>2、精通常用开源第三方组件或开源工程；<br>3、熟悉使用Idea、Maven、Git等版本集成、开发工具；<br>4、熟悉掌握Mysql，oracle数据库设计以及sql优化；<br>5、熟悉Linux操作系统，熟悉命令行和相关工具；<br>6、本科以上学历，3年以上工作经验；<br>7、参与过大型软件系统开发或项目经验者优先。</div>
    </div>
  </div>
  

  <div class="crumbs-nav">
      <svg t="1647833705034" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3680" width="0.2rem" height="0.2rem"><path d="M938.412716 480.847489 556.823881 104.126522c-1.89721-2.258437-6.142907-6.194072-12.037151-10.081613-9.920954-6.544043-21.162995-10.520611-33.496905-10.520611-13.180184 0-24.690332 3.997034-34.357506 10.623965-5.846148 4.010337-9.876951 8.102538-12.157901 11.154038L84.209914 480.894561c-14.700817 14.481829-14.700817 38.014802 0 52.529377 14.585183 14.427594 33.995255 8.343015 50.529837-7.945973l25.607214-25.314549 38.918381-37.700647c-1.359974 1.686409-2.282996 2.963495-2.284019 3.373841L196.981327 847.484797c0 50.006927 40.941458 90.427522 91.442642 90.427522l141.713582 0 10.423397 0L440.560948 927.486876 440.560948 686.440961c0-17.467837 14.411221-31.683607 32.223912-31.683607l77.051887 0c17.814738 0 32.223912 14.21577 32.223912 31.683607L582.060659 927.486876l0 10.425444 10.425444 0 141.713582 0c50.485835 0 91.442642-40.428781 91.442642-90.427522L825.642327 467.251843l62.246693 61.207014c20.142759 13.266142 37.897122 17.434068 50.523697 4.963035C953.114556 518.910387 953.114556 495.361041 938.412716 480.847489z" p-id="3681" fill="#c6c6c6"></path></svg>
      <div class="crumbs-text1"  @click="goToHome">首页</div>
      <div class="crumbs-text2" @click="goJoin">加入我们</div>
      <div class="crumbs-text3" @click="goSocial">社会招聘</div>
      <div class="crumbs-text4">JAVA开发工程师</div>
      <img src="../../../../assets/images/路径 93.png" alt="" class="crumbs-img1" @click="goToHome">
      <img src="../../../../assets/images/路径 94.png" alt="" class="crumbs-img2" @click="goJoin">
      <img src="../../../../assets/images/路径 95(1).png" alt="" class="crumbs-img3" @click="goSocial">
      <img src="../../../../assets/images/路径 96.png" alt="" class="crumbs-img4">
    </div>
  <Footer></Footer>
</div>
</template>

<script>
import Upload from "@/componets/upload/upload"
import Footer from "@/componets/footer/Footer"
export default {
  data() {
    return {
    }
  },
  components: {
    Footer,
    Upload,
  },
  methods: {
    goToHome() {
      this.$router.push('/home')
    },
    goSocial() {
      this.$router.back()
    },
    goJoin() {
      this.$router.push('/join/recruitment')
    }
  },
}
</script>

<style lang = "less" scoped>
.social_front_end-container {
  width: 19.2rem;
  font-family: Source Han Sans CN;
  font-size: 0.22rem;
   position: relative;
}
.content {
  width: 12rem;
  margin: 0.9rem auto 1.1rem auto;
}
.content-header {
  width: 12rem;
  height: 0.98rem;
}
/* 头部的LOGO */
.header-logo {
  width: 0.98rem;
  height: 0.98rem;
  background-image: url("../../../../assets/logo/java.png");
  background-size: 0.98rem 0.98rem;
  background-repeat: no-repeat;
  float: left;
}
/* 头部的文字部分 */
.header-text {
  width: 3rem;
  height: 0.98rem;
  text-align: left;
  margin-left: 0.3rem;
  float: left;
}
.header-text1 {
  font-size: 0.38rem;
  font-weight: 400;
  line-height: 0.56rem;
  color: #333333;
}
.header-text2 {
  font-size: 0.22rem;
  font-family: DIN;
  font-weight: 400;
  line-height: 0.27rem;
  color: #ADADAD;
}
/* 头部的投递 */
.header-btn {
  width: 1.6rem;
  height: 0.54rem;
  float: right;
  border-radius: 0.54rem;
  cursor: pointer;
  color: #FFFFFF;
  background-color: #0078FF;
}
/*头部下方的文字*/
.content-detailed {
  width: 12rem;
  height: 0.33rem;
  margin-top: 0.51rem;
  color: #999999;
  display: flex;
}
.content-detailed img {
  width: 0.15rem;
  height: 0.22rem;
}
.detailed-text2 {
  margin-left: 0.46rem;
  margin-right: 5.19rem;
  position: relative;
}
/* 两个竖线 */
.detailed-text2::before {
  content: "";
  width: 0.02rem;
  height: 0.2rem;
  background-color: #DADFE3;
  position: absolute;
  top: 0.06rem;
  left: 1.28rem;
}
.detailed-text2::after {
  content: "";
  width: 0.02rem;
  height: 0.2rem;
  background-color: #DADFE3;
  position: absolute;
  top: 0.06rem;
  right: 0.95rem;
}
/* 工作内容描述 */
.content-job {
  margin-top: 0.6rem;
  text-align: left;
}
.job-title {
  width: 1.12rem;
  height: 0.41rem;
  font-size: 0.28rem;
  line-height: 0.41rem;
  margin-bottom: 0.54rem;
  color: #333333;
  position: relative;
}
.job-title::after {
  content: '';
  width: 0.38rem;
  height: 0.04rem;
  background-color: #0078FF;
  position: absolute;
  top: 0.61rem;
  left: 0rem;
}
.job-text {
  font-weight: 400;
  line-height: 0.5rem;
  color: #666666;
}
/* 蓝色的面包屑导航 */
.crumbs-nav {
  width: 8rem;
  height: 0.6rem;
  font-size: 0.16rem;
  position: relative;
  position: absolute;
  top: -1.2rem;
  left: 2.6rem;
  z-index: 999;
}
.crumbs-nav img {
  cursor: pointer;
}
.icon {
  position: absolute;
  top: 0.18rem;
  left: 0.41rem;
  z-index: 99;
}
.crumbs-text1 {
  cursor: pointer;
  position: absolute;
  top: 0.18rem;
  left: 0.73rem;
  color: #C6C6C6 ;
  z-index: 99;
}
.crumbs-text2 {
  cursor: pointer;
  position: absolute;
  top: 0.18rem;
  left: 1.73rem;
  color: #C6C6C6 ;
  z-index: 99;
}
.crumbs-text3 {
  cursor: pointer;
  position: absolute;
  top: 0.18rem;
  left: 3.14rem;
  color: #C6C6C6 ;
  z-index: 99;
}
.crumbs-text4 {
  cursor: pointer;
  position: absolute;
  top: 0.18rem;
  left: 4.55rem;
  color: #FFFFFF;
  z-index: 99;
}
.crumbs-img1 {
  width: 1.45rem;
  height: 0.6rem;
  position: absolute;
  left: 0;
  z-index: 3;
}
.crumbs-img2 {
  width: 2.04rem;
  height: 0.6rem;
  position: absolute;
  left: 0.72rem;
  z-index: 2;
}
.crumbs-img3 {
  width: 2.07rem;
  height: 0.6rem;
  position: absolute;
  left: 2.17rem;
  z-index: 1
}
.crumbs-img4 {
  width: 2.62rem;
  height: 0.6rem;
  position: absolute;
  left: 3.7rem;
}
</style>